var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSort(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148707",
    "data-name": "Rectangle 148707",
    width: 20,
    height: 20,
    transform: "translate(1749 150)",
    fill: "#0c0c0b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sorting",
    transform: "translate(-1749 -150)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11910",
    "data-name": "Group 11910",
    transform: "translate(1750.983 151.899)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9094",
    "data-name": "Path 9094",
    d: "M137.235,21.562l2.487-2.487v13.79a.535.535,0,0,0,1.069,0V19.075l2.487,2.487a.538.538,0,0,0,.376.158.515.515,0,0,0,.376-.158.533.533,0,0,0,0-.756l-3.4-3.4a.541.541,0,0,0-.376-.158.518.518,0,0,0-.376.158l-3.4,3.4a.533.533,0,1,0,.752.756Z",
    transform: "translate(-136.325 -17.25)",
    fill: "#0c0c0b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9095",
    "data-name": "Path 9095",
    d: "M137.235,29.088l2.487,2.487V17.785a.535.535,0,1,1,1.069,0V31.575l2.487-2.487a.538.538,0,0,1,.376-.158.515.515,0,0,1,.376.158.533.533,0,0,1,0,.756l-3.4,3.4a.541.541,0,0,1-.376.158.518.518,0,0,1-.376-.158l-3.4-3.4a.533.533,0,0,1,.752-.756Z",
    transform: "translate(-127.882 -17.25)",
    fill: "#0c0c0b"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.f0d2d092.svg";
export { ForwardRef as ReactComponent };